import { render } from "./ResearchOfficerDetailComponent.vue?vue&type=template&id=68b1bbf0&scoped=true"
import script from "./ResearchOfficerDetailComponent.vue?vue&type=script&lang=js"
export * from "./ResearchOfficerDetailComponent.vue?vue&type=script&lang=js"

import "./ResearchOfficerDetailComponent.vue?vue&type=style&index=0&id=68b1bbf0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b1bbf0"]])

export default __exports__